import React, { useLayoutEffect, useRef } from 'react';
import { generateClassNameByBehaviorSettings } from '../../../../utils/behaviorSettings';
import { LinkWithLabel } from '../../../../types';
import Button from '../../../01_atoms/Button';
import bodyBlockAnimation from '../../../../utils/bodyBlockAnimation';
import { BehaviourSettingsType } from '../../../../utils/behaviorSettings/prop-types';

import s from './index.module.scss';

type ItemProps = {
  description: string;
  button: LinkWithLabel;
  icon:
    | 'people'
    | 'heart'
    | 'hand-under-heart'
    | 'heart-over-hands'
    | 'hand-under-circle'
    | 'precise-heart'
    | 'hand-under-leaf';
};

type Props = {
  heading: string;
  items: ItemProps[];
  behaviorSettings?: BehaviourSettingsType;
  uuid?: string;
};

const BBUpselling = ({ heading, items, behaviorSettings = {}, uuid = undefined }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  // Add animation handler for the block.
  useLayoutEffect(() => {
    if (ref.current) {
      bodyBlockAnimation(ref.current);
    }
  }, [ref]);

  return (
    <div
      className={`bb ${s['bb-upselling']} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
      id={uuid}
      data-component="upselling"
      ref={ref}
    >
      <div className="container">
        <div className={s['bb-upselling__root']}>
          <div className={s['bb-upselling__wrapper']}>
            <div className={s['bb-upselling__heading']}>{heading}</div>
            <div className={s['bb-upselling__items']}>
              {items.map((item, index) => (
                <div className={s['bb-upselling__item']} key={index}>
                  <div className={s['bb-upselling__item-wrapper']}>
                    <div
                      className={`${s['bb-upselling__item-icon']} ${s['bb-upselling__item-icon--' + item.icon]}`}
                    ></div>
                    <div className={s['bb-upselling__item-content']}>
                      <div className={s['bb-upselling__item-description']}>
                        <p>{item.description}</p>
                      </div>
                      <div className={s['bb-upselling__item-button']}>
                        {item.button.nextLink && (
                          <Button
                            size={'small'}
                            tag="a"
                            type={'secondary'}
                            isTransparent={!!index}
                            isOutlined={!!index}
                            href={item.button.nextLink.url}
                            className={'transparent'}
                            withArrow={true}
                          >
                            {item.button.label}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BBUpselling;
